<template>
    <div href="#" class="item">
        <div :class="'icon-box bg-' + colorTxt(tx)">
            <ion-icon :name="iconTxt(tx)" role="img" class="md hydrated"></ion-icon>
        </div>
        <div class="in">
            <div>
            <div class="mb-05">
                <strong>{{ infoTxt(tx) }}</strong>
            </div>
            <div v-if="tx.lockDetails != null && tx.lockDetails != undefined" class="text-small mb-05">{{ labelTxt(tx) }} con ID: {{ tx.lockDetails != null && tx.lockDetails != undefined ? $root.recortarCadena(tx.lockId) : '' }} ({{ tx.status_text }})</div>
            <div v-else class="text-small mb-05">{{ labelTxt(tx) }}</div>

            <template v-if="tx.lockDetails != null && tx.lockDetails != undefined">
                <!-- <div class="text-xsmall">lockId: {{tx.lockId}}</div> -->
                <template v-if="tx.status == 0">
                </template>
                <template v-else-if="tx.status == 1">
                <div class="text-xsmall">Bonus: {{realAmount(tx.lockDetails.bonus, tx.asset.currency.decimals)}}</div>
                <div class="text-xsmall">Falta: {{ (lockTimeCalc(tx.lock_reward)) }}</div>
                <div class="text-xsmall">Registrado: {{tx.created}}</div>
                <div class="text-xsmall">Inica: {{tx.lock_start}} - Termina: {{ tx.lock_reward }}</div>
                </template>
                <template v-else-if="tx.status == 2 && tx.lockDetails.cancelated == true">
                <div class="text-xsmall">Bonus perdido: {{realAmount(tx.lockDetails.bonus, tx.asset.currency.decimals)}}</div>
                </template>
            </template>
            
            <!-- <div class="text-xsmall">{{tx.lockDetails}}</div> -->
            </div>
            <span :class="'text-' + colorAmount(tx) + ' text-end'">
                {{ tx.amount }} {{ tx.asset.currency.symbol }} <br />
                <a v-if="tx.type == 'locked' && tx.status == 1 && tx.lockDetails.completed == false && lockTimeCalcSuccess(tx.lock_reward)" :href="'/withdraw/blocking/' + tx.id" class="badge badge-success">Reclamar</a>
                <a v-if="tx.type == 'locked' && tx.status == 1 && tx.lockDetails.completed == false" :href="'/canceled/blocking/' + tx.id" class="badge badge-danger">Cancelar</a>
            </span>
            <!-- {{ tx }} -->
        </div>
    </div>
</template>

<script>
export default {
    props: ['tx'],
    methods: {
        colorTxt(tx) {
            if (tx.type == 'recharge') {
            if (tx.status == 1) return `success`;
            }
            else if (tx.type == 'locked') {
                if (tx.status == 1) {
                    if (tx.lockDetails.withdrawn == true) {
                        return `success`;
                    }
                    else if (tx.lockDetails.cancelated == true) {
                        return `danger`;
                    }
                    else if (tx.lockDetails.seized == true) {
                        return `warning`;
                    }
                    // Math.floor(Date.now() / 1000)
                    return `info`;
                }
                else if (tx.status == 2) {
                if (tx.lockDetails.cancelated == true) {
                    return `danger`;
                }
                else if (tx.lockDetails.withdrawn == true) {
                    return `success`;
                }
                }
                else if (tx.status == 3) return `success`;
                // else if (tx.status == 2) return `danger`;
                else if (tx.status == 0) return `danger`;
            }
            else if (tx.type == 'withdraw') {
            if (tx.status == 1) return `success`;
            }
            else if (tx.type == 'transfer') {
            if (tx.status == 1) return `success`;
            return 'danger';
            }
            return `secondary`;
        },
        labelTxt(tx) {
            if (tx.type == 'recharge') {
                return `Recarga desde ${tx.network.name} `;
            }
            else if (tx.type == 'locked') {
                console.log(tx.type_status)
                return `Bloqueo de ${tx.asset.currency.symbol}`;
            }
            else if (tx.type == 'withdraw') {
                console.log('withdraw', tx)
                return `Envio para otra red desde ${tx.asset.network.name}`;
            }
            else if (tx.type == 'transfer') {
                return `Transferencia de ${tx.asset.currency.symbol}`;
            }
            return "Desconocido-label";
        },
        realAmount(amount, decimals) {
            return (amount) / (10 ** decimals);
        },
        lockTimeCalcSuccess(dateString) {
            const timestampInSeconds = Math.floor(Date.now() / 1000);
            const timestamp = this.convertToTimestamp(dateString);
            const timeInDays = timestamp - timestampInSeconds;
            const timeInMinutes = (timeInDays / 60);
            const timeInMinutesFinal = parseInt(timeInMinutes);
            return timeInMinutesFinal <= 0;
        },
        lockTimeCalc(dateString) {
            const timestampInSeconds = Math.floor(Date.now() / 1000);
            // console.log('timestampInSeconds', timestampInSeconds)
            const timestamp = this.convertToTimestamp(dateString);
            // console.log('timestamp', timestamp)
            const timeInDays = timestamp - timestampInSeconds;
            // console.log('timeInDays', timeInDays)
            const timeInMinutes = (timeInDays / 60);
            // console.log('timeInMinutes', timeInMinutes)
            const timeInMinutesFinal = parseInt(timeInMinutes);
            // console.log('timeInMinutesFinal', timeInMinutesFinal)
            return this.$root.convertirTiempo(timeInMinutesFinal);
        },
        colorAmount(tx) {
            if (tx.type == 'recharge') {
            if (tx.status == 1) return `success`;
            }
            else if (tx.type == 'locked') {
                if (tx.status == 1) {
                    if (tx.lockDetails.withdrawn == true) {
                        return `success`;
                    }
                    else if (tx.lockDetails.cancelated == true) {
                        return `danger`;
                    }
                    else if (tx.lockDetails.seized == true) {
                        return `warning`;
                    }
                    // Math.floor(Date.now() / 1000)
                    return `info`;
                }
                else if (tx.status == 2) {
                if (tx.lockDetails.cancelated == true) {
                    return `danger`;
                }
                else if (tx.lockDetails.withdrawn == true) {
                    return `success`;
                }
                }
                else if (tx.status == 3) return `success`;
                // else if (tx.status == 2) return `danger`;
                else if (tx.status == 0) return `danger`;
            }
            else if (tx.type == 'withdraw') {
            if (tx.status == 1) return `danger`;
            }
            else if (tx.type == 'transfer') {
            if (tx.status == 1) return `danger`;
            return 'warning';
            }
            return `secondary`;
        },
        iconTxt(tx) {
            if (tx.type == 'recharge') {
            return `add-outline`;
            }
            else if (tx.type == 'locked') {
                if (tx.status == 1 && tx.lockDetails.withdrawn == true) {
                    return `lock-open-outline`;
                }
                else if (tx.status == 2 && tx.lockDetails.withdrawn == true) {
                    return `shield-checkmark-outline`;
                }
                else if (tx.status == 2 && tx.lockDetails.cancelated == true) {
                    return `close-outline`;
                }
                else if (tx.status == 1 && tx.lockDetails.seized == true) {
                    return `close-circle-outline`;
                }
                else if (tx.status == 1 && tx.lockDetails.completed == false) {
                    return `stopwatch-outline`;
                }
            //   if (tx.status == 3 && tx.type == 'locked') return 'lock-open-outline'
            //   else if (tx.status == 1 && tx.type == 'locked') return 'close-outline'
            return `remove-outline`;
            }
            else if (tx.type == 'withdraw') {
                return `arrow-down-outline`;
            }
            else if (tx.type == 'transfer') {
            return `arrow-forward-outline`;
            }
            return "bug-outline";
        },
        infoTxt(tx) {
            if (tx.type == 'recharge') {
            let res = `Recarga desde ${tx.network.name}`
                if (tx.status == 0) res += " Fallida (Solo creada)";
                if (tx.status == 1) res += " Exitosa";
                return res;
            }
            else if (tx.type == 'locked') {
                return `Agregarte liquidez en ${tx.asset.currency.symbol} x ` + this.$root.convertirTiempo(tx.lock_time);
            }
            else if (tx.type == 'withdraw') {
                return `Retiro de ${tx.asset.currency.symbol} `;
            }
            else if (tx.type == 'transfer') {
                console.log(`Enviaste ${tx.asset.currency.symbol} a una wallet interna`, tx)
                return `Enviaste ${tx.asset.currency.symbol} a una wallet interna`;
            }
            return "Desconocido-infoTxt";
        },
        convertToTimestamp(dateString) {
            const date = new Date(dateString.replace(/-/g, '/').replace(/T/, ' ').replace(/\.[\d]{3}/, ''));
            return date.getTime() / 1000;
        },
    },
}
</script>